// extracted by mini-css-extract-plugin
module.exports = {"container":"ExternalLink_container__T9Tib","link":"ExternalLink_link__3hof0"};